import type { ReactNode } from "react";
import { Toggle } from "../Toggle";

export function ModelAvailabilityToggle({
  checked,
  label,
  icon,
  disabled,
  busy,
  onChange,
}: {
  checked: boolean;
  label: string;
  icon: ReactNode;
  disabled?: boolean;
  busy?: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <label
      title={label}
      className="flex cursor-pointer items-center gap-1.5 rounded-lg px-2 py-1.5"
    >
      <span aria-hidden="true" className="text-stone-500 dark:text-stone-400">
        {icon}
      </span>
      <Toggle
        checked={checked}
        aria-label={label}
        disabled={disabled || busy}
        onClick={(event) => event.stopPropagation()}
        onChange={(event) => onChange(event.target.checked)}
      />
    </label>
  );
}
